<template>
    <div class="ucomply-page">
      <div class="loading-spinner-outer" v-if="sending">
        <div class="loading-spinner-inner">
          <div class="loading-spinner"></div>
          <div class="loading-spinner-content">
            Sending, please wait
          </div>
        </div>
      </div>
        <div class="landing-page-introduction-box">
            <div class="title">
                <div>
                    U-Comply N
                </div>
                <div class="logo">
                    <img src="/images/u-comply-logo.jpg" style="height: 45px;">
                </div>
            </div>
            <div class="box-1">
                <h1>U-Comply N Customer Portal</h1>
                <p>
                    Log in to the U‑Comply N calculator to accurately calculate the thermal efficiency ratings of your products and support compliance requirements.
                </p>
                <p>
                    We’ve also included quick links to approved glazing manufacturers to help you source the performance data you need - covering energy, thermal, acoustic, environmental performance and more.
                </p>
                <div class="flex justify-around m-a" style="max-width: 600px;">
                    <div class="flex flex-col justify-around">
                        <a href="https://spectrum.pilkington.com/" target="_blank">
                            <img src="https://spectrum.pilkington.com/images/logo.png">
                        </a>
                    </div>
                    <div class="flex flex-col justify-around">
                        <a href="https://calumen.com/#/home" target="_blank">
                            <img src="https://calumen.com/assets/app/images/light/Saint-Gobain-logo-light.png">
                        </a>
                    </div>
                    <div class="flex flex-col justify-around">
                        <a href="https://www.guardianglass.com/eu/en/portal/home" target="_blank">
                            <img src="https://d2gc27jy00o0yk.cloudfront.net/assets/us-east-1_xiseFMEV3/b0f7a697-f6cc-4650-a00d-f6845e6721ae/1d9039fe-3350-438f-94ca-68e5dbe462a9/dark-form_logo.png">
                        </a>
                    </div>
                </div>
                <p>
                    If your chosen glass supplier isn’t listed, you’ll need to obtain this performance information directly from your glass manufacturer.
                </p>
                <div>
                    <a class="btn-primary _lg" href="https://ucomply.epwinwsd.co.uk/" target="_blank" @click="partnerLinkClicked()">
                        Login to U Comply N
                    </a>
                </div>
            </div>
            <div class="overlapping-image">
                <img src="/images/technical-ucomply-header.png">
            </div>
            <div class="box-2">
                <p>
                    If you do not have an account get in touch to get set up
                </p>
                <div>
                    <a class="btn-primary-outline _lg" @click.stop="enquiry_box_open = true">
                        Request an account
                    </a>
                </div>
            </div>
        </div>
        <div class="modal-window" :class="{'open': enquiry_box_open}" @click="enquiry_box_open = false">
            <div class="modal-window-inner" @click.stop>
                <div class="modal-close" @click.stop="enquiry_box_open = false">
                    <i class="fal fa-times"></i>
                </div>
                <div class="modal-header">
                    <h1 class="modal-title">U-Comply N Enquiry</h1>
                </div>
                <div class="modal-content">
                    <div class="form-group">
                        Which brands are required?
                      <div class="checkboxes">
                        <label class="checkbox">
                          <input type="checkbox" value="Profile 22" v-model="selected_system_types">
                          <span class="checkbox-label"> Profile 22 </span>
                        </label>
                        <label class="checkbox mt-1">
                          <input type="checkbox" value="Spectus" v-model="selected_system_types">
                          <span class="checkbox-label"> Spectus </span>
                        </label>
                        <label class="checkbox mt-1">
                          <input type="checkbox" value="Stellar" v-model="selected_system_types">
                          <span class="checkbox-label"> Stellar </span>
                        </label>
                      </div>
                    </div>
                    <textarea rows="5" v-model="enquiry_message" class="form-control"></textarea>
                </div>
                <div class="modal-footer align-right">
                    <a class="btn-primary" @click="sendEnquiry()">
                        Send
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        'logged_in_user',
    ],
    data() {
        return {
            'enquiry_box_open': false,
            'enquiry_message': 'I would like some information on signing up for the U Comply N Portal',
          selected_system_types: [],
          sending: false,
        }
    },
    methods: {
        sendEnquiry() {
          this.enquiry_box_open = false;
          this.sending = true;
          const message = this.enquiry_message + ' - Brands required: ' + this.selected_system_types.join(", ");
            axios.post('/enquiry/send', {
                'enquiry_type_id': 12,
                'message': message,
            }).then((response) => {

              gtag('event', 'enquiry_made', {
                'event_category': 'enquiries',
                'event_label': 'U Comply N enquiry',
                'value': 'U Comply N enquiry',
              });

                this.sending = false;
                Swal.fire({
                    title: 'Enquiry Sent',
                    icon: 'success',
                    text: 'Your enquiry has been sent, you will be sent a notification when you receive a reply.'
                });
            });
        },
      partnerLinkClicked() {
        axios.post('/activity-logs/createActivityLogFromRequest', {
          'activity_log_category_id': 3,
          'description': `Partner Link Clicked - U Comply`,
        });
        gtag('event', 'partner_link_clicked', {
          'event_category': 'link',
          'event_label': 'U Comply partner link clicked',
          'value': 'U Comply partner link clicked',
        });
      },
    },
};
</script>
